import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import MyReservations from './components/MyReservations';
import MyProfile from './components/MyProfile';
import Cpanel from './components/Cpanel';
import CpanelDashboard from './components/CpanelDashboard';
import EventsManagement from './components/EventsManagement';
import Register from './components/Auth/Register';
import Evenements from './components/EventList';
import AdminPanel from './components/Admin/AdminPanel';
import EventForm from './components/EventForm';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Services from './pages/Services';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Login from './components/Auth/Login';
import EventDetail from './components/EventDetail';
import EventReservation from './components/EventReservation';
import EventList from './components/EventList';

// Import the ResetPassword component
import ResetPassword from './components/Auth/ResetPassword';


// Import the CookieConsent component at the top of your file
import CookieConsent from './components/CookieConsent/CookieConsent';
import ResetPasswordConfirm from  './components/Auth/ResetPasswordConfirm';

// Then in your App component's render method, add it at the bottom:
// Add this import
import EmailConfirmation from './components/EmailConfirmation';



function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* Fix the comment syntax and add reset password routes */}
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/confirm/:uid/:token" element={<ResetPasswordConfirm />} />
          // Add this route in your Routes component
          <Route path="/confirm-email/:key" element={<EmailConfirmation />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Evenements" element={<Evenements />} /> 
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/my-reservations" element={<MyReservations />} />
          <Route path="/reservation/:id" element={<EventReservation/>} />
          
          {/* Cpanel routes */}
          <Route path="/cpanel" element={<Cpanel />}>
            <Route index element={<CpanelDashboard />} />
            <Route path="dashboard" element={<CpanelDashboard />} />
            <Route path="events" element={<EventsManagement />} />
            <Route path="events/add" element={<EventForm />} />
            <Route path="statistics" element={<div><h2>Statistiques</h2><p>Cette section est en cours de développement</p></div>} />
            <Route path="settings" element={<div><h2>Paramètres</h2><p>Cette section est en cours de développement</p></div>} />
          </Route>
          
          {/* Admin routes */}
          <Route path="/admin/*" element={<AdminPanel />} />
          
          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        {/* Add CookieConsent inside the Router */}
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;

